(() => {
  'use strict';
  const KEY = 'bronxWishlistV1';

  function readCount() {
    try {
      const value = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(value)) return 0;
      const handles = new Set();
      value.forEach((item) => {
        const handle = typeof item?.handle === 'string' ? item.handle.trim().toLowerCase() : '';
        if (handle) handles.add(handle);
      });
      return handles.size;
    } catch (_error) {
      return 0;
    }
  }

  function sync() {
    const count = readCount();
    document.querySelectorAll('[data-bx-wishlist-count]').forEach((node) => {
      node.textContent = String(count);
      node.hidden = count === 0;
      node.setAttribute('aria-label', `${count} saved ${count === 1 ? 'product' : 'products'}`);
    });
    document.querySelectorAll('[data-bx-wishlist-count-inline]').forEach((node) => {
      node.textContent = `(${count})`;
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, { once: true });
  else sync();
  window.addEventListener('storage', (event) => { if (event.key === KEY) sync(); });
  document.addEventListener('bronx:wishlist:change', sync);
  document.addEventListener('shopify:section:load', sync);
})();
